// @flow
import React, { useState } from 'react';

import { getAccordianPanelDetailsObject } from '../../common-utils/utils';
import { useEstimateDealDurationYears } from '../../custom-hooks/useEstimateDealDurationYears';
import { YearSelectionContext } from '../cluster/YearSelectionContext';
import { AccordionsList } from '../presentational/accordions/AccordionsList';

import { NativeInferencePoolDetailsContainer } from './native-inference-pool-details-inputs-section/NativeInferencePoolDetailsContainer';
import { NativeInferencePoolUsageContainer } from './native-inference-pool-details-inputs-section/NativeInferencePoolUsageContainer';
import { NativeInferencePoolSummaryContainer } from './native-inference-pool-summaries/NativeInferencePoolSummaryContainer';

export const NativeInferencePoolAccordionsContainer = () => {
  const totalYears = useEstimateDealDurationYears();
  const [selectedYear, setSelectedYear] = useState(1);

  const accordionPanels = [
    getAccordianPanelDetailsObject(
      'Inference Pool Details',
      <NativeInferencePoolDetailsContainer />
    ),
    getAccordianPanelDetailsObject('Inference Pool Usage', <NativeInferencePoolUsageContainer />),
    getAccordianPanelDetailsObject(
      'Inference Pool Summary',
      <NativeInferencePoolSummaryContainer />
    ),
  ];

  return (
    <YearSelectionContext.Provider
      value={{
        totalYears,
        selectedYear,
        setSelectedYear,
      }}
    >
      <AccordionsList panels={accordionPanels} />
    </YearSelectionContext.Provider>
  );
};
